export function snakeToCamel(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(function (item) {
      return snakeToCamel(item);
    });
  }
  var result = {};
  Object.keys(obj).forEach(function (key) {
    var camelKey = key.replace(/_\w/g, function (m) {
      return m[1].toUpperCase();
    });
    // @ts-ignore
    result[camelKey] = snakeToCamel(obj[key]);
  });
  return result;
}